import * as React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { tr } from '../../utils/translations/translator';

interface SignupCredentialsNoticeProps {
  email: string;
  // Replaces the /login link, e.g. the checkout switches to its login tab.
  onLogin?: () => void;
}

// Shown when the signup email + password can't be used (409/403). Reuses the
// login copy so it doesn't reveal whether the account exists.
export const SignupCredentialsNotice: React.FC<SignupCredentialsNoticeProps> = ({
  email,
  onLogin,
}) => {
  const { t } = useTranslation();
  const query = `?email=${encodeURIComponent(email)}`;
  const ctaClassName = 'font-semibold underline hover:text-red-300';

  return (
    <div
      role="alert"
      className="bg-red-500/10 border border-red-500/30 rounded-xl px-4 py-3 text-sm text-red-400 space-y-2"
    >
      <p className="font-medium">{tr(t, 'login_error_wrong-pwd')}</p>
      <div className="flex flex-wrap gap-x-4 gap-y-1">
        {onLogin ? (
          <button
            type="button"
            className={ctaClassName}
            onClick={(e) => {
              // The checkout cards select their method on click.
              e.stopPropagation();
              onLogin();
            }}
          >
            {tr(t, 'login_login')}
          </button>
        ) : (
          <Link to={`/login${query}`} className={ctaClassName}>
            {tr(t, 'login_login')}
          </Link>
        )}
        <Link to={`/recover-password${query}`} className={ctaClassName}>
          {tr(t, 'login_recover-password')}
        </Link>
      </div>
    </div>
  );
};
